import { lightenColor } from '@/pages/hes/command/includes/utils';
import { FC } from 'react';

type ResultStatusProps = {
  status: string;
};

type ToggleResult = {
  'NOT EXECUTED': string;
  COMPLETED: string;
  ERROR: string;
  EXECUTING: string;
  PROCESSING: string;
  SUCCESS: string;
  FAILED: string;
  INITIATE: string;
  PENDING: string;
  'IN PROGRESS': string;
  'IN-PROGRESS': string;
};

const ResultStatus: FC<ResultStatusProps> = ({ status }) => {
  const toggleResult: ToggleResult = {
    'NOT EXECUTED': '#ABC7FF',
    COMPLETED: '#00D1AF',
    ERROR: '#FF716D',
    EXECUTING: '#3B68FF',
    PROCESSING: '#3B68FF',
    FAILED: '#FF716D',
    SUCCESS: '#00D1AF',
    INITIATE: '#FFC32E',
    PENDING: '#3B68FF',
    'IN PROGRESS': '#FFC32E',
    'IN-PROGRESS': '#FFC32E'
  };
  return (
    <div
      className="batch-status"
      style={{
        color: toggleResult[status as keyof ToggleResult],
        backgroundColor:
          lightenColor(toggleResult[status as keyof ToggleResult], 0.9) ||
          'grey',
        border: `0.5px solid ${toggleResult[status as keyof ToggleResult]}`
      }}>
      {status}
    </div>
  );
};

export default ResultStatus;
